import React from "react";
import Select from "react-select";
import Switch from "react-switch";
import { Controller } from "react-hook-form";
import { NumberField } from "../../../../../../Utils/renderField/fieldsHookForms";
import { RenderKilogramo } from "../../../../../../Utils/renderField/renderReadField";
import { DecisionSwal } from "../../../../../../Utils/Utils/DecisionSwal";

const eliminarIcon = require("assets/img/icons/borrar.png");
const alertaIcon = require("assets/img/icons/alerta_roja.png");

export const SobranteTurno = ({ cierreTurnoForm }) => {
    const {
        formControl,
        formErrors,
        productosTrabajados,
        sobrantesTurno,
        haySobranteTurno,
        AgregarSobrante,
        EliminarSobrante,
    } = cierreTurnoForm;

    const cardClassName = "my-3 p-3 border-gray rounded-xl gap-1rem";

    const selectHaySobranteTurno = (
        <Controller
            name="hay_sobrante_turno"
            control={formControl}
            rules={{
                required: "Este campo es obligatorio",
            }}
            render={({ field }) => (
                <Select
                    {...field}
                    className="react-select-container"
                    backspaceRemovesValue={false}
                    isSearchable
                    options={[
                        {
                            value: true,
                            label: "Sí",
                        },
                        {
                            value: false,
                            label: "No",
                        },
                    ]}
                    placeholder="Seleccionar"
                />
            )}
        />
    );

    if (!haySobranteTurno) {
        return (
            <div className={`${cardClassName} align-items-center`}>
                <div className="d-flex align-items-center gap-1rem justify-content-end">
                    <h5 className="mb-1 text-right text-nowrap">
                        ¿Hay sobrante de kg secos en el turno?
                    </h5>

                    <div style={{ minWidth: "200px" }}>
                        {selectHaySobranteTurno}
                        {formErrors.hay_sobrante_turno && (
                            <small className="text-danger">
                                {formErrors.hay_sobrante_turno.message}
                            </small>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={`formulario-fields-column ${cardClassName}`}>
            <div className="d-flex align-items-center gap-1rem justify-content-between mb-1">
                <h5>Kg secos sobrantes</h5>
                {sobrantesTurno.length > 0 && (
                    <Controller
                        name="enviar_bodega_sobrante"
                        control={formControl}
                        render={({ field }) => {
                            const confirmarCambio = (checked) => {
                                const texto = checked
                                    ? "Los sobrantes serán enviados a bodega y no podrán ser utilizados por el siguiente supervisor."
                                    : "El sobrante no se enviará a bodega y quedará disponible para que lo utilice el siguiente supervisor.";

                                DecisionSwal(
                                    texto,
                                    "Sí, continuar",
                                    "Cancelar",
                                    () => field.onChange(checked),
                                );
                            };

                            return (
                                <div
                                    className="d-flex align-items-center gap-10"
                                    style={{ height: "fit-content" }}
                                >
                                    <img
                                        src={alertaIcon}
                                        alt="Alerta"
                                        className="title_img pb-1"
                                    />
                                    <label className="mb-0 pl-0 text-nowrap">
                                        ¿Enviar sobrantes a bodega?
                                    </label>
                                    <Switch
                                        onColor="#007bff"
                                        height={18}
                                        width={36}
                                        onChange={confirmarCambio}
                                        checked={!!field.value}
                                    />
                                </div>
                            );
                        }}
                    />
                )}
            </div>

            <div className="formulario-fields-row gap-1rem my-0 flex-wrap align-items-end">
                <div className="formulario-field">
                    <label className="text-nowrap">
                        ¿Hay sobrante de kg secos en el turno?
                    </label>
                    {selectHaySobranteTurno}
                    {formErrors.hay_sobrante_turno && (
                        <small className="text-danger">
                            {formErrors.hay_sobrante_turno.message}
                        </small>
                    )}
                </div>

                <div className="formulario-field">
                    <label className="text-nowrap">Producto</label>
                    <Controller
                        name="producto_sobrante"
                        control={formControl}
                        render={({ field }) => (
                            <Select
                                {...field}
                                className="react-select-container"
                                backspaceRemovesValue={false}
                                isSearchable
                                isClearable
                                options={productosTrabajados}
                                getOptionValue={(option) =>
                                    option.orden_produccion_id
                                }
                                getOptionLabel={(option) =>
                                    option.padre_producto_terminado_nombre
                                        ? `${option.padre_producto_terminado_nombre} - ${option.producto_nombre}`
                                        : option.producto_nombre
                                }
                                placeholder="Seleccionar"
                            />
                        )}
                    />
                    {formErrors.producto_sobrante && (
                        <small className="text-danger">
                            {formErrors.producto_sobrante.message}
                        </small>
                    )}
                </div>

                <div className="formulario-field">
                    <label className="text-nowrap">Kg sobrante conforme</label>
                    <NumberField
                        control={formControl}
                        name="kg_secos_sobrantes_conforme_nuevo"
                        errors={formErrors}
                        allowNegative={false}
                        suffix=" Kg"
                        placeholder="00.00 Kg"
                        decimalScale={3}
                    />
                </div>

                <div className="formulario-field">
                    <label className="text-nowrap">
                        Kg sobrante no conforme
                    </label>
                    <NumberField
                        control={formControl}
                        name="kg_secos_sobrantes_no_conforme_nuevo"
                        errors={formErrors}
                        allowNegative={false}
                        suffix=" Kg"
                        placeholder="00.00 Kg"
                        decimalScale={3}
                    />
                </div>

                <div className="formulario-field mb-0 no-flex">
                    <button
                        type="button"
                        className="btn btn-primary text-nowrap"
                        onClick={AgregarSobrante}
                    >
                        Agregar
                    </button>
                </div>
            </div>

            <div className="new-table-wrapper mt-2">
                <table className="table-striped">
                    <thead>
                        <tr>
                            <th>Producto</th>
                            <th>Kg conforme</th>
                            <th>Kg no conforme</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {sobrantesTurno.length === 0 && (
                            <tr>
                                <td colSpan={4} className="text-center">
                                    No se han agregado sobrantes
                                </td>
                            </tr>
                        )}
                        {sobrantesTurno.map((item, index) => (
                            <tr key={item.orden_produccion_id}>
                                <td className="text-center text-nowrap">
                                    {item.producto_nombre}
                                </td>
                                <td className="text-center text-nowrap">
                                    <RenderKilogramo
                                        value={item.kg_secos_sobrantes_conforme}
                                        decimals={3}
                                    />
                                </td>
                                <td className="text-center text-nowrap">
                                    <RenderKilogramo
                                        value={
                                            item.kg_secos_sobrantes_no_conforme
                                        }
                                        decimals={3}
                                    />
                                </td>
                                <td className="text-center text-nowrap">
                                    <img
                                        src={eliminarIcon}
                                        alt="Eliminar"
                                        title="Eliminar"
                                        className="action_img"
                                        onClick={() => EliminarSobrante(index)}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
